export enum PassengerTypeEnum {
    adult = "ADULT",
    child = "CHILD",
    infant = "INFANT",
    senior = "SENIOR",
    student = "STUDENT",
    prm = "PRM",
    wheelchair = "WHEELCHAIR"
}